import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import SelectSearch from 'react-select-search';
import { SlideDown } from 'react-slidedown';
import Icon from '../../../../icons';
import { ARROW_DOWN } from '../../../../constants/iconNames';
import Variables from '../../../../styles/variables.scss';
export default function CategoryDropdown({ categories, toggleCategoryDropdown, selectedCategory, show, type, value, }) {
    const showDropdown = show && categories.length > 0;
    return (categories.length > 0 && (_jsxs("div", { className: "category_dropdown", children: [_jsxs("button", { onClick: () => toggleCategoryDropdown(type), children: [_jsx("span", { children: value }), _jsx("span", { className: showDropdown ? 'category_dropdown--icon-up' : 'category_dropdown--icon-down', children: _jsx(Icon, { name: ARROW_DOWN, stroke: Variables.opacityWhiteLight }) })] }), _jsx(SlideDown, { className: "slidedown", transitionOnAppear: true, closed: !showDropdown, children: _jsx("div", { className: "select-search-box__container", children: showDropdown && (_jsx(SelectSearch, { autofocus: true, handleClickOutside: () => { }, onChange: selectedCategory, options: categories, value: value, search: false })) }) })] })));
}
CategoryDropdown.propTypes = {
    categories: PropTypes.arrayOf(PropTypes.any).isRequired,
    toggleCategoryDropdown: PropTypes.func.isRequired,
    selectedCategory: PropTypes.func.isRequired,
    show: PropTypes.bool.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
};
